import React from "react";
import { ArrowRight, Leaf } from "lucide-react";

const About = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="about" className="relative bg-[#fbf9f4] py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-14 md:gap-20 items-start">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c4a257]" />
              <span className="text-[#c4a257] text-xs tracking-[0.3em] uppercase font-medium">
                About Tatva
              </span>
            </div>
            <h2 className="font-serif text-[38px] md:text-[52px] leading-[1.05] text-[#1b5e3a] mb-8">
              Health Rejuvenation
              <br />
              <span className="italic text-[#2c7a4a]">Through Nature</span>
            </h2>
            <div className="space-y-5 text-[#3a4a3d] text-[16px] leading-[1.75]">
              <p>
                Tatva Wellness Center is open with the intention of providing
                health rejuvenation lifestyle with naturopathy practices. We
                believe that true healing goes beyond treating symptoms — it is
                about reconnecting with the body&apos;s own intelligence.
              </p>
              <p>
                Our multidisciplinary team combines ancient wisdom with modern
                naturopathic science to deliver personalised care that addresses
                physical, mental, emotional and holistic dimensions of health.
              </p>
              <p>
                Whether you are managing a chronic condition, recovering from
                injury or simply seeking restoration and balance, Tatva is your
                sanctuary for deep, lasting wellness.
              </p>
            </div>
            <button
              onClick={() => scrollTo("#book")}
              className="group mt-10 inline-flex items-center gap-3 bg-[#1b5e3a] hover:bg-[#164d30] text-white text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 rounded-md shadow-[0_8px_20px_rgba(27,94,58,0.25)] transition-all duration-300 hover:-translate-y-0.5"
            >
              Book a Consultation
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          {/* Feature card */}
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-[#eaf1e6] blur-2xl opacity-70" />
            <div className="relative bg-white border border-[#e6ded0] rounded-2xl p-8 md:p-10 shadow-[0_20px_60px_rgba(27,94,58,0.08)]">
              <div className="w-14 h-14 rounded-full bg-[#eaf1e6] flex items-center justify-center mb-6">
                <Leaf className="w-6 h-6 text-[#1b5e3a]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl text-[#1b5e3a] mb-4">
                Rooted in Nature. Guided by Science.
              </h3>
              <p className="text-[#3a4a3d] leading-relaxed mb-8">
                Every treatment plan is customised. We listen first, then
                design a journey combining traditional wisdom with modern
                evidence-based naturopathy.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-6 border-t border-[#eee4d0]">
                <div>
                  <p className="font-serif text-4xl text-[#1b5e3a]">10+</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#6b7568] mt-1">
                    Therapies
                  </p>
                </div>
                <div>
                  <p className="font-serif text-4xl text-[#1b5e3a]">08</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#6b7568] mt-1">
                    Expert Doctors
                  </p>
                </div>
                <div>
                  <p className="font-serif text-4xl text-[#1b5e3a]">100%</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#6b7568] mt-1">
                    Natural
                  </p>
                </div>
                <div>
                  <p className="font-serif text-4xl text-[#1b5e3a]">1:1</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#6b7568] mt-1">
                    Personalised
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
